export const genericError = "Something went wrong";

export const throttle = (func: any, delay = 250) => {
  let shouldWait = false;

  return (...args: any) => {
    if (shouldWait) {
      return;
    }

    func(...args);
    shouldWait = true;
    setTimeout(() => {
      shouldWait = false;
    }, delay);
  };
};
